import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'

import styles from '../../../styles/bantrab/components/input.module.scss'

const Search = ({
  solid, outline, inputType, placeholder, icon, solidColor,
  borderColor, borderActiveColor, ...attrs
}) => {
  // if (solid && outline) {
  //   solid = !solid
  // }

  const { className } = attrs
  attrs.className = classNames(className,
    [
      'flex'
    ],
    {
      [styles.search]: true,
      [styles.solid]: solid,
      [styles.outline]: outline,
      [styles[solidColor]]: !!solidColor,
      [styles.borderColor]: borderColor,
      [styles[borderActiveColor]]: !!borderActiveColor
    })

  return (
    <div {...attrs}>
      <Typography>
        <input className="pl-12 pr-4" type={inputType} placeholder={placeholder} />
      </Typography>
      <figure className="search-icon flex items-center left-4">
        {icon}
      </figure>
    </div>
  )
}

Search.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  solidColor: PropTypes.oneOf(['light-gray']),
  borderActiveColor: PropTypes.oneOf(['light-green']),
  inputType: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  // placeholder: PropTypes.oneOf([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  solid: PropTypes.bool,
  outline: PropTypes.bool,
  borderColor: PropTypes.bool
}

export default Search
